import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { Horizontal, Vertical } from '@sorare/core/src/atoms/layout/flex';
import { BrandM } from '@sorare/core/src/atoms/typography';
import { Bezel } from '@sorare/core/src/atoms/ui/bezels/Bezel';
import { glossary } from '@sorare/core/src/lib/glossary';
import { tabletAndAbove } from '@sorare/core/src/style/mediaQuery';

import { CashRewards } from './CashRewards';
import jersey from './assets/jersey.png';
import matchTickets from './assets/match-tickets.png';

const Root = styled(Vertical).attrs({ gap: 2 })`
  flex: 1;
  justify-content: center;
`;
const Padding = styled(Horizontal).attrs({ center: true })`
  width: 100%;
  padding: var(--unit) var(--double-unit);
`;

const WayMore = styled(BrandM)`
  align-self: center;
  padding-top: var(--double-unit);
`;

const OtherItems = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--double-unit);
  @media ${tabletAndAbove} {
    flex-direction: row;
  }
`;

const items = [
  {
    key: 'item-2',
    img: jersey,
    messageDescriptor: glossary.signedJerseys,
  },
  {
    key: 'item-3',
    img: matchTickets,
    messageDescriptor: glossary.matchTickets,
  },
] as const;

export const WinItems = () => {
  return (
    <Root gap={2}>
      <CashRewards />
      <OtherItems>
        {items.map(({ key, img, messageDescriptor }) => (
          <Bezel
            key={key}
            background="conic-gradient(from 90deg at 3px 3px, var(--c-nd-50) 25%, var(--c-black) 0) 0 0/5px 5px"
          >
            <Padding>
              <Horizontal gap={2} center>
                <img src={img} alt="" height={83} />
                <BrandM>
                  <FormattedMessage {...messageDescriptor} />
                </BrandM>
              </Horizontal>
            </Padding>
          </Bezel>
        ))}
      </OtherItems>
      <WayMore>
        <FormattedMessage
          id="TutorialPage.andWayMore"
          defaultMessage="And way more!"
        />
      </WayMore>
    </Root>
  );
};
